<div class="mat-dropdown" [class.has-option-icons]="configuration().hasOptionIcons">
  <label *ngIf="(formControl.value?.length || 0) > 0 && configuration().text" class="mat-dropdown-label">
    {{ formControl.value?.length ? configuration().label : configuration().text || configuration().label }}
  </label>
  <angular2-multiselect
    class="mat-dropdown"
    [repositionDropdownList]="configuration().repositionDropdownList"
    [ngClass]="{
      'has-errors': (!formControl.pristine || isFormSubmitted) && formControl.errors,
      'mat-dropdown-placeholder-color':
        !formControl.value?.length && ((formControl.pristine && !isFormSubmitted) || !formControl.errors)
    }"
    [data]="configuration().isClientSide ? searchFilteredOptions() : data"
    [settings]="configuration()"
    [formControl]="formControl"
    (onOpen)="onOpen()"
    (onClose)="onClose()"
  >
    @if (configuration().hasOptionIcons) {
      <c-item>
        <ng-template let-option="item">
          <span class="option-with-icon">
            <mat-icon class="option-icon" [style.color]="option.iconColor">{{ option.icon }}</mat-icon>
            <span class="option-label">{{ option.name }}</span>
          </span>
        </ng-template>
      </c-item>
    }
    <c-search class="p-2">
      <ng-template>
        <div class="search-row">
          <mat-form-field appearance="outline" class="p-2" subscriptSizing="dynamic">
            <mat-label>{{ 'field.search' | translate }}</mat-label>
            <input matInput [formControl]="searchControl" (keyup)="onSearch()" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
          @if (actionIcon()) {
            <button
              type="button"
              mat-mini-fab
              class="search-action-button"
              [attr.aria-label]="actionLabel()"
              [matTooltip]="actionLabel()"
              (click)="onActionClick($event)"
            >
              <mat-icon>{{ actionIcon() }}</mat-icon>
            </button>
          }
        </div>
      </ng-template>
    </c-search>
  </angular2-multiselect>
  <mat-progress-bar
    *ngIf="isLoading()"
    class="app-progress-bar position-absolute"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
<app-custom-mat-error
  *ngIf="configuration().hasMatError"
  [control]="formControl"
  [isFormSubmitted]="isFormSubmitted"
></app-custom-mat-error>
